// extracted by mini-css-extract-plugin
export default {"section-navigation-menu":"SectionNavigationMenu_section-navigation-menu__a-zyH","item":"SectionNavigationMenu_item__Ta-0m"};